// extracted by mini-css-extract-plugin
export default {"fadeOutAnimation":"fadeOutAnimation__VAqQ2","darkModeFilter":"darkModeFilter__GV5GR"};